#define LAYER_TYPE_DEFAULT 0.0
#define LAYER_TYPE_ANIMATED_MARKERS 1.0
#define LAYER_TYPE_NO_DEPTH 2.0
#define MAX_LAYERS 10

varying vec2 v_texCoord;
uniform sampler2D layerTextures[MAX_LAYERS];
uniform vec4 layerInfo[MAX_LAYERS];
uniform float time;
uniform int layerCount;  // actual number of layers passed from JavaScript


vec4 arrayTexture2D(int layer, vec2 uv) {
    vec4 result = vec4(0.0);
    if (layer == 0) result = texture2D(layerTextures[0], uv);
    else if (layer == 1) result = texture2D(layerTextures[1], uv);
    else if (layer == 2) result = texture2D(layerTextures[2], uv);
    else if (layer == 3) result = texture2D(layerTextures[3], uv);
    else if (layer == 4) result = texture2D(layerTextures[4], uv);
    else if (layer == 5) result = texture2D(layerTextures[5], uv);
    else if (layer == 6) result = texture2D(layerTextures[6], uv);
    else if (layer == 7) result = texture2D(layerTextures[7], uv);
    else if (layer == 8) result = texture2D(layerTextures[8], uv);
    else if (layer == 9) result = texture2D(layerTextures[9], uv);
    return result;
}

vec4 arrayLayerInfo(int layer) {
    if (layer == 0) return layerInfo[0];
    if (layer == 1) return layerInfo[1];
    if (layer == 2) return layerInfo[2];
    if (layer == 3) return layerInfo[3];
    if (layer == 4) return layerInfo[4];
    if (layer == 5) return layerInfo[5];
    if (layer == 6) return layerInfo[6];
    if (layer == 7) return layerInfo[7];
    if (layer == 8) return layerInfo[8];
    if (layer == 9) return layerInfo[9];
    return vec4(0.0);  // Fallback if out of range.
}

vec4 layerDefault(vec4 layerInfo, vec4 baseColor, vec4 layerColor, float deltaDepth) {
    if (layerColor.a > 0.0 && deltaDepth < 0.0) {
        float softBlend = min(1.0, -deltaDepth * 10.0) * layerInfo.a;
        return mix(baseColor, layerColor, softBlend);
    }
    return baseColor;
}

vec3 markerFilter(vec4 baseColor, vec4 layerColor) {
    float cameraDistance = layerColor.a;
    float wave = sin((cameraDistance / 2.0 - time) * 3.0) / 2.0 + 2.0;
    float alpha = 1.0; //wave;

    float offset = layerColor.r - 0.5;
    vec3 color = vec3(baseColor.r + offset, baseColor.g + offset, baseColor.b + offset);

    return mix(baseColor.rgb, color, alpha);
}

vec4 animatedMarkers(vec4 layerInfo, vec4 baseColor, vec4 layerColor, float deltaDepth) {
    if (layerColor.a > 0.0) {
        vec3 markerColor = markerFilter(baseColor, layerColor);
        float alpha = clamp(-deltaDepth + 1.0, 0.0, 1.0);
        return vec4(mix(baseColor.rgb, markerColor.rgb, alpha), layerColor.a);
    }
    return baseColor;
}

vec4 noDepth(vec4 layerInfo, vec4 baseColor, vec4 layerColor) {
    if (layerColor.a > 0.0) {
        return vec4(mix(baseColor.rgb, layerColor.rgb, layerColor.a * layerInfo.a), baseColor.a);
    }
    return baseColor;
}

vec4 renderLayers(vec4 baseColor) {
    for (int i = 0; i < layerCount; i++) {
        vec4 layerInfo = arrayLayerInfo(i);
        vec4 layerColor = arrayTexture2D(i, v_texCoord);
        float deltaDepth = layerColor.a - baseColor.a;
        float layerType = layerInfo.b;


        if (layerType == LAYER_TYPE_ANIMATED_MARKERS) {
            baseColor = layerDefault(layerInfo, baseColor, layerColor, deltaDepth);
            //baseColor = animatedMarkers(layerInfo, baseColor, layerColor, deltaDepth);
        } else if (layerType == LAYER_TYPE_NO_DEPTH) {
            baseColor = noDepth(layerInfo, baseColor, layerColor);
        } else {
            baseColor = layerDefault(layerInfo, baseColor, layerColor, deltaDepth);
        }
    }
    return baseColor;
}
